import type { GameProfile } from '../types';

const GREEN = '#2E7D32';
const BLUE = '#2C4F8C';

export const ball6: GameProfile = {
  id: 'ball-6',
  label: '6 Balls (1–6)',
  ballIds: [1, 2, 3, 4, 5, 6],
  // Matches the betting UI: odd numbers green (1, 3, 5), even blue (2, 4, 6).
  colorFor: (id) => (id % 2 === 1 ? GREEN : BLUE),
  textureStyle: 'standard',
  machineCount: 1,
  resultsPerDraw: 1,
};
